/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.DatePicker || (M.Template.DatePicker = {});

M.Template.DatePicker.Picker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2013 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n\n';
 if (shouldDisplayDateLabel) { 
__p+='\n  <span class="dateLabel"> '+
((__t=( monthName ))==null?'':__t)+
'  '+
((__t=( dayOfMonth ))==null?'':__t)+
',\n    '+
((__t=( fullYear ))==null?'':__t)+
' - <a class="changeDate">change</a></span>\n';
 } 
__p+='\n';
 if (shouldDisplayDateLabel) { 
__p+='\n  <div class="pickerWrap" style="display:none;">\n';
 } 
__p+='\n<select class="monthSelect form__field-select form__field-select--month"></select>\n<select class="daySelect form__field-select form__field-select--day"></select>\n';
 if (showYear === true) { 
__p+='\n  <select class="yearSelect form__field-select form__field-select--year"></select>\n';
 } 
__p+='\n';
 if (shouldDisplayDateLabel) { 
__p+='\n  </div>\n';
 } 
__p+='\n';
}
return __p;
});


return {};

});
/* end templito generated file */
